import { FontWeights, IButtonStyles, ICheckboxStyleProps, ICheckboxStyles, IStyleFunctionOrObject, mergeStyles, mergeStyleSets } from "@fluentui/react";

export const rowContainerStyles = mergeStyles([{
    width: '100%',
    height: '1rem',
    margin: '1.5dvh'
}]);

export const mdRowContainerStyles = mergeStyles([{
    width: '100%',
    height: '7dvh'
}]);

export const smRowContainerStyles = mergeStyles([{
    width: '100%',
    height: '6dvh'
}]);

//#region LIST CONTAINER

export const listContainerStyles = mergeStyles([{
    width: '100%',
    marginTop: '2dvh',
    gap: '1dvh'
}]);

export const xxlListContainerStyles = mergeStyles([{
    width: '100%',
    marginTop: 'clamp(3.5dvh, 4dvh, 4.5dvh)',
    gap: 'clamp(0.8dvh, 1dvh, 1.2dvh)'
}]);

export const xlListContainerStyles = mergeStyles([{
    width: '100%',
    marginTop: 'clamp(3.5dvh, 4dvh, 4.5dvh)',
    gap: 'clamp(0.8dvh, 1dvh, 1.2dvh)'
}]);

export const lgListContainerStyles = mergeStyles([{
    width: '100%',
    marginTop: 'clamp(3.5dvh, 4dvh, 4.5dvh)',
    gap: 'clamp(0.8dvh, 1dvh, 1.2dvh)'
}]);

export const mdListContainerStyles = mergeStyles([{
    width: '100%',
    marginTop: 'clamp(3.5dvh, 4dvh, 4.5dvh)',
    gap: 'clamp(0.8dvh, 1dvh, 1.2dvh)'
}]);

export const smListContainerStyles = mergeStyles([{
    width: '100%',
    marginTop: 'clamp(4.5dvh, 5dvh, 5.5dvh)',
    gap: 'clamp(0.8dvh, 1dvh, 1.2dvh)'
}]);

//#endregion LIST CONTAINER

export const registerScenarioRowContainerStyles = mergeStyles([{
    width: '100%',
    padding: '1dvh',
    backgroundColor: '#F0F0F0',
    cursor: 'pointer',
    borderRadius: '5px'
}]);

export const registerScenarioRowContainerSelectedStyles = mergeStyles([{
    width: '100%',
    backgroundColor: '#F0F0F0',
    cursor: 'pointer',
    borderRadius: '5px',
    border: '2px solid #a9c963'
}]);

export const registerScenarioRowInnerContainerSelectedStyles = mergeStyles([{
    width: 'inherit',
    padding: '1dvh',
    backgroundColor: 'rgba(169, 201, 99, 0.2)'
}]);

export const registerScenarioRowTextContainerStyles = mergeStyles([{
    gap: '0.5dvh',
}]);

export const registerScenarioRowCheckboxStyles: IStyleFunctionOrObject<ICheckboxStyleProps, ICheckboxStyles> = {
    root: {
        borderRadius: '50%'
    },
    checkbox: {
        borderRadius: '50%'
    }
}

//#region ROW TITLE

export const titleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: '1.2rem',
    fontWeight: 600,
    color: '#2A7DE1',

    textAlign: 'left'
}]);

export const xxlTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.95rem, 2.5vw, 1rem)',
    fontWeight: 600,
    color: '#2A7DE1',

    textAlign: 'left'
}]);

export const xlTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.9rem, 2.5vw, 0.95rem)',
    fontWeight: 600,
    color: '#2A7DE1',

    textAlign: 'left'
}]);

export const lgTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.85rem, 2.5vw, 0.9rem)',
    fontWeight: 600,
    color: '#2A7DE1',

    textAlign: 'left'
}]);

export const mdTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.8rem, 2.5vw, 0.85rem)',
    fontWeight: 600,
    color: '#2A7DE1',

    textAlign: 'left'
}]);

export const smTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.75rem, 2.5vw, 0.8rem)',
    fontWeight: 600,
    color: '#2A7DE1',

    textAlign: 'left'
}]);

//#endregion ROW TITLE

//#region ROW DESCRIPTION

export const descriptionStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: '1rem',
    fontWeight: 300,
    color: '#323130',

    textAlign: 'left'
}]);

export const xxlDescriptionStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.85rem, 2.5vw, 0.9rem)',
    fontWeight: 300,
    color: '#323130',

    textAlign: 'left'
}]);

export const xlDescriptionStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.8rem, 2.5vw, 0.85rem)',
    fontWeight: 300,
    color: '#323130',

    textAlign: 'left'
}]);

export const lgDescriptionStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.75rem, 2.5vw, 0.8rem)',
    fontWeight: 300,
    color: '#323130',

    textAlign: 'left'
}]);

export const mdDescriptionStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.7rem, 2.5vw, 0.75rem)',
    fontWeight: 300,
    color: '#323130',

    textAlign: 'left'
}]);

export const smDescriptionStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.65rem, 2.5vw, 0.7rem)',
    fontWeight: 300,
    color: '#323130',

    textAlign: 'left'
}]);

//#endregion ROW DESCRIPTION

export const registerScenarioSuggestButtonStyles: IButtonStyles = {
    root: {
        fontFamily: 'Nunito',
        fontSize: '1rem',
        fontWeight: 800,
    }
}

export const modalContentStyles = mergeStyleSets({
    container: {
        display: 'flex',
        flexFlow: 'column nowrap',
        alignItems: 'stretch',
    },
    header: {
        flex: '1 1 auto',
        borderTop: `4px solid #2A7DE1`,
        color: '#2A7DE1',
        display: 'flex',
        alignItems: 'center',
        fontFamily: 'Nunito',
        fontWeight: FontWeights.semibold,
        padding: '12px 12px 14px 24px',
    },
    heading: {
        color: '#2A7DE1',
        fontFamily: 'Nunito',
        fontWeight: FontWeights.semibold,
        fontSize: 'inherit',
        margin: '0',
    },
    body: {
        flex: '4 4 auto',
        padding: '0 24px 24px 24px',
        overflowY: 'hidden'
    },
  });
  
  export const modalIconButtonStyles: Partial<IButtonStyles> = {
    root: {
        color: '#323130',
        marginLeft: 'auto',
        marginTop: '4px',
        marginRight: '2px',
    },
    rootHovered: {
        color: '#2A7DE1',
    },
  };